import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import {AppInjector, AppModule} from './app/app.module';
import { environment } from './environments/environment';
import {NGXLogger} from "ngx-logger";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => AppInjector.get(NGXLogger).error(err));
